import DashboardLayout from '../../components/DashboardLayout'
import OrgCollectionForm from '@components/OrgCollectionForm'
import useEditOrgCollectionPage from './useEditOrgCollectionPage'

export default function EditOrgCollectionPage() {
    const {
        values,
        setValue,
        handleSubmit,
        formValid,
        loading,
        error,
        admins,
        orgs,
        validationErrors,
    } = useEditOrgCollectionPage()
    return (
        <DashboardLayout>
            <OrgCollectionForm
                title="Edit Org Collection"
                values={values}
                setValue={setValue}
                formValid={formValid}
                handleSubmit={handleSubmit}
                loading={loading}
                error={error}
                validationErrors={validationErrors}
                admins={admins}
                orgs={orgs}
            />
        </DashboardLayout>
    )
}
